import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { doesStudentExist, getLastStudentID } from "state/school_money/selectors";
import { setLastStudent } from "state/school_money/actions";

import { Redirect } from "react-router";

import Gate from "components/Gate";

class MaintainValidStudentID extends React.Component {
  
  static propTypes = {
    currentStudentID: PropTypes.string,
    generatePath: PropTypes.func.isRequired
  }
  
  updateLastStudent() {
    const { currentStudentID, isCurrentStudentIDValid, lastStudentID } = this.props;
    if (isCurrentStudentIDValid && currentStudentID !== lastStudentID) {
      this.props.setLastStudent(currentStudentID);
    }
  }
  
  componentDidMount() {
    this.updateLastStudent();
  }
  
  componentDidUpdate() {
    this.updateLastStudent();
  }
  
  render() {
    const { isCurrentStudentIDValid, lastStudentID } = this.props;
    const redirect = <Redirect to={this.props.generatePath(lastStudentID)} />;
    return (
      <Gate isOpen={isCurrentStudentIDValid} placeholder={redirect}>
        {this.props.children}
      </Gate>
    );
  }
  
}

export default connect(
  (state, ownProps) => {
    const { currentStudentID } = ownProps;
    const isCurrentStudentIDDefined = currentStudentID !== undefined;
    return {
      isCurrentStudentIDValid: isCurrentStudentIDDefined && doesStudentExist(state, currentStudentID),
      lastStudentID: getLastStudentID(state)
    }
  },
  { setLastStudent }
)(MaintainValidStudentID);



// WEBPACK FOOTER //
// ./src/components/school_money/MaintainValidStudentID.js